import React, { useState } from 'react'
import { useStyle } from "./Style";
import Grid from "@material-ui/core/Grid";
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import FilterClaims from '../Claims/FilterClaims';
import { ClaimStatusEnum } from '../../enum';
import { getPartnerGuid } from '../../../../../lib/access.es6';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const BASE_TABS = [
  { label: 'Docs Pending', status: ClaimStatusEnum.docs_pending },
  { label: 'Verification', status: ClaimStatusEnum.verification },
  { label: 'Approved', status: ClaimStatusEnum.Approved },
  { label: 'Rejected', status: ClaimStatusEnum.Rejected },
];

// Only OMK parks a rejection in Rejected_Pending awaiting confirmation, so the
// tab would be permanently empty for everyone else on this dashboard.
const claimTabs = () =>
  getPartnerGuid() === 'omk'
    ? BASE_TABS.concat([
      { label: 'Rejected Pending', status: ClaimStatusEnum.Rejected_Pending },
    ])
    : BASE_TABS;

const ClaimsWrapper = (props) => {
  const classes = useStyle();
  const [value, setValue] = useState(0);
  const tabs = claimTabs();

  const getClaimStatus = (tabValue) =>
    (tabs[tabValue] || tabs[0]).status;

  const handleChange = (event, newValue) => {
    setValue(newValue);
    const status = getClaimStatus(newValue);
    props.getClaimsByStatus(status, function() {
      props.getClaimsFiltered();
    });
  };

  const sharedFilterProps = {
    pagingData: props.pagingData,
    claimsData: props.claimsData,
    loading: props.loading,
    type: props.type,
    getClaimsFiltered: props.getClaimsFiltered,
    getClaimsByStartDate: props.getClaimsByStartDate,
    getClaimsByEndDate: props.getClaimsByEndDate,
    hasBulkApprove: props.hasBulkApprove,
    handleBulkApproval: props.handleBulkApproval,
    hasAlerts: props.hasAlerts,
    showBulkApproveProgressAlert: props.showBulkApproveProgressAlert,
    showBulkApproveSuccessAlert: props.showBulkApproveSuccessAlert,
    showBulkApproveErrorAlert: props.showBulkApproveErrorAlert,
    bulkApproveError: props.bulkApproveError,
    resetBulkApproveSuccessAlert: props.resetBulkApproveSuccessAlert,
    resetBulkApproveErrorAlert: props.resetBulkApproveErrorAlert,
  };

  return (
    <>
      <section className={classes.claimswrapper}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="claims dashboards"
                variant="scrollable"
                scrollButtons="auto"
                className={classes.tabs}
              >
                {tabs.map((tab, index) => (
                  <Tab
                    key={tab.label}
                    label={tab.label}
                    {...a11yProps(index)}
                    disabled={props.loading}
                  />
                ))}
              </Tabs>
            </Box>
            {tabs.map((tab, index) => (
              <TabPanel key={tab.label} value={value} index={index}>
                <FilterClaims {...sharedFilterProps} />
              </TabPanel>
            ))}
          </Grid>
        </Grid>
      </section>
    </>
  );
};

export default ClaimsWrapper;
